'use client';

import Image from 'next/image';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { useSelectedLayoutSegment } from 'next/navigation';
import { useMenuActions } from '@noirproperties/react/menu-provider/menu-hooks';
import { useUser } from '@/providers/user-hooks';
import type { NavigationItems } from '@/menus/main-menu';

type AppBarProps = {
  navigation: NavigationItems;
};

export default function AppBar({ navigation }: AppBarProps) {
  const { toggleMenu } = useMenuActions();
  const user = useUser();
  const segment = useSelectedLayoutSegment();

  const title =
    navigation.find((item) => item.activeSegment === segment)?.name ??
    'Dashboard';

  return (
    <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-sm sm:px-6 lg:hidden">
      <button
        className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
        onClick={toggleMenu}
        type="button"
      >
        <span className="sr-only">Open sidebar</span>
        <Bars3Icon aria-hidden="true" className="h-6 w-6" />
      </button>
      <div className="flex-1 text-sm font-semibold leading-6 text-gray-900">
        {title}
      </div>
      <a href="#">
        <span className="sr-only">Your profile</span>
        <Image
          alt=""
          className="h-8 w-8 rounded-full bg-gray-50"
          height={32}
          // TODO: Fallback image
          src={user.picture}
          width={32}
        />
      </a>
    </div>
  );
}
